import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AboutPageComponents/MandatoryDisclosure/MandatoryDisclosure.tsx");
